import { Injectable } from '@angular/core';
import { ConfirmationModalComponent } from '../confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  constructor(private _translate: TranslateService, private _bsModalService: BsModalService) {}

  /**
   * @function showConfirmationModal
   * @description Erstellt ein Modal zur Bestätigung der ausgeführten Aktion.
   * @param confirmMessage: confirm Text zum übersetzen und anzeigen
   * @return boolean
   */
  public showConfirmationModal(confirmMessage: string): Observable<any> {
    // Get Translation by key für inaktiv setzen
    return this._translate.get(confirmMessage).pipe(
      mergeMap(modal => {
        // Erstellt ein neues Modal Instanz der ConfirmationModalComponent und gibt ein Modalreferenz zurück
        const modalRef = this._bsModalService.show(ConfirmationModalComponent);
        // Setze alle nötigen Felder auf das erstelle Modalreferenz
        modalRef.content.modalTitle = modal.TITLE;
        modalRef.content.modalMessage = modal.BODY;

        // Subscribe auf Confirmation
        return modalRef.content.onConfirmSubject.pipe(
          map(confirm => {
            // Sobald confirm bestätigt ist, Modal ausblenden
            modalRef.hide();
            return confirm;
          })
        );
      })
    );
  }
}
